const ComponentTypes = {
  FETCH_TEMPLATE_DETAILS: 'FETCH_TEMPLATE_DETAILS',
  CLEAR_REDUCER_TEMPLATE: 'CLEAR_REDUCER_TEMPLATE',
  GET_EDIT_DATA: 'GET_EDIT_DATA',
  FETCH_PURCHASE_ORDER: 'FETCH_PURCHASE_ORDER',
  DOWNLOAD_ZIP_URL: 'DOWNLOAD_ZIP_URL',
  SUPPLIER_TYPE: 'SUPPLIER_TYPE',
  SUPPLIER_LIST: 'SUPPLIER_LIST',
  PURCHASE_ORDER_BY_ID: 'PURCHASE_ORDER_BY_ID',
  CONTACT_USER_DATA: 'CONTACT_USER_DATA',
  FETCH_UNIT_OF_MEASURE: 'FETCH_UNIT_OF_MEASURE',
  FETCH_UPLOAD_DOCUMENTS: 'FETCH_UPLOAD_DOCUMENTS',
  SET_CREATED_BY_USER: 'SET_CREATED_BY_USER',
};

export default ComponentTypes;
